import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const PrivacyPolicy = () => {
  return (
    <>
      <SEO 
        title="Privacy Policy"
        description="Privacy Policy for Stephanies Luxe Solutions. Learn how we collect, use, and protect your personal information in compliance with UAE and GDPR regulations."
        canonical="https://stephaniesluxesolutions.com/privacy-policy"
      />
      <div style={{ background: '#F5F0E8', minHeight: '100vh', fontFamily: 'DM Sans, sans-serif' }}>
      {/* Header */}
      <nav style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: '#F5F0E8',
        borderBottom: '0.5px solid #DDD4C0',
        padding: '16px 48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <div style={{
            fontFamily: 'Cormorant Garamond, serif',
            fontSize: '22px',
            fontWeight: 400,
            color: '#2C1F14',
            letterSpacing: '0.04em'
          }}>
            <span style={{ opacity: 0.2 }}>S</span>L<span style={{ opacity: 0.2 }}>S</span>
          </div>
        </Link>
        <Link 
          to="/"
          style={{
            fontSize: '10.5px',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: '#6B5744',
            textDecoration: 'none'
          }}
        >
          ← Back to Home
        </Link>
      </nav>

      {/* Content */}
      <article style={{ maxWidth: '900px', margin: '0 auto', padding: '80px 40px' }}>
        <h1 style={{
          fontFamily: 'Cormorant Garamond, serif',
          fontSize: '48px',
          fontWeight: 300,
          color: '#2C1F14',
          marginBottom: '20px'
        }}>
          Privacy Policy
        </h1>

        <p style={{ color: '#6B5744', fontSize: '14px', marginBottom: '40px' }}>
          Last updated: 8 April 2026
        </p>

        <div style={{ fontSize: '15px', color: '#2C1F14', lineHeight: 1.8, fontWeight: 300 }}>
          <section style={{ marginBottom: '40px' }}>
            <p style={{ marginBottom: '16px' }}>
              Stephanies Luxe Solutions ("we," "our," or "us") is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
              when you visit our website.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: '28px',
              fontWeight: 300,
              color: '#2C1F14',
              marginBottom: '16px'
            }}>
              1. Information We Collect
            </h2>
            
            <h3 style={{
              fontSize: '18px',
              fontWeight: 400,
              color: '#2C1F14',
              marginBottom: '12px',
              marginTop: '20px'
            }}>
              Personal Information
            </h3>
            <p style={{ marginBottom: '12px' }}>
              We may collect personal information that you voluntarily provide when you:
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '16px' }}>
              <li>Subscribe to our newsletter</li>
              <li>Schedule a consultation through Calendly</li>
              <li>Contact us via email</li>
              <li>Fill out forms on our website</li>
            </ul>
            <p style={{ marginBottom: '16px' }}>
              This may include your name, email address, phone number, and any other information you choose to provide.
            </p>

            <h3 style={{
              fontSize: '18px',
              fontWeight: 400,
              color: '#2C1F14',
              marginBottom: '12px',
              marginTop: '20px'
            }}>
              Automatically Collected Information
            </h3>
            <p style={{ marginBottom: '16px' }}>
              When you visit our website, we may automatically collect certain information using cookies and similar technologies, including:
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '16px' }}>
              <li>IP address</li>
              <li>Browser type and version</li>
              <li>Pages visited and time spent on pages</li>
              <li>Referring website</li>
              <li>Operating system</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: '28px',
              fontWeight: 300,
              color: '#2C1F14',
              marginBottom: '16px'
            }}>
              2. Cookies and Tracking
            </h2>
            
            <h3 style={{
              fontSize: '18px',
              fontWeight: 400,
              color: '#2C1F14',
              marginBottom: '12px',
              marginTop: '20px'
            }}>
              Consent for Cookies and Google Analytics
            </h3>
            <p style={{ marginBottom: '16px' }}>
              We respect your privacy and comply with UAE Data Protection Law (PDPL 2022) and international privacy standards. 
              Non-essential cookies, including Google Analytics, will only be activated after your explicit consent through our cookie banner.
            </p>
            <p style={{ marginBottom: '16px' }}>
              You can withdraw or change your cookie preferences at any time.
            </p>

            <h3 style={{
              fontSize: '18px',
              fontWeight: 400,
              color: '#2C1F14',
              marginBottom: '12px',
              marginTop: '20px'
            }}>
              Essential Cookies
            </h3>
            <p style={{ marginBottom: '16px' }}>
              Essential cookies are necessary for the website to function properly. They:
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '16px' }}>
              <li>Remember your cookie consent preferences</li>
              <li>Enable core website functionality</li>
              <li>Cannot be disabled without affecting website operation</li>
            </ul>

            <h3 style={{
              fontSize: '18px',
              fontWeight: 400,
              color: '#2C1F14',
              marginBottom: '12px',
              marginTop: '20px'
            }}>
              Google Analytics
            </h3>
            <p style={{ marginBottom: '16px' }}>
              We use Google Analytics to understand how visitors interact with our website. This helps us improve your experience and our services. Google Analytics collects information such as:
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '16px' }}>
              <li>Number of visitors and geographic location</li>
              <li>Pages viewed and duration of visit</li>
              <li>Traffic sources</li>
              <li>Device and browser information</li>
            </ul>
            <p style={{ marginBottom: '16px' }}>
              You can opt out of Google Analytics by declining non-essential cookies or by installing the{' '}
              <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" 
                style={{ color: '#C4A882', textDecoration: 'underline' }}>
                Google Analytics Opt-out Browser Add-on
              </a>.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: '28px',
              fontWeight: 300,
              color: '#2C1F14',
              marginBottom: '16px'
            }}>
              3. How We Use Your Information
            </h2>
            <p style={{ marginBottom: '12px' }}>We use the information we collect to:</p>
            <ul style={{ marginLeft: '30px', marginBottom: '16px' }}>
              <li>Respond to inquiries and provide customer service</li>
              <li>Send newsletters and marketing communications (with your consent)</li>
              <li>Analyze website usage and trends</li>
              <li>Schedule and manage consultations</li>
              <li>Improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: '28px',
              fontWeight: 300,
              color: '#2C1F14',
              marginBottom: '16px'
            }}>
              4. Third-Party Services
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We may share your data with trusted third-party services, including:
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '16px' }}>
              <li><strong>Google Analytics:</strong> Website analytics (only with consent)</li>
              <li><strong>Calendly:</strong> Appointment scheduling</li>
            </ul>
            <p style={{ marginBottom: '16px' }}>
              These third parties have their own privacy policies. We encourage you to review them.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: '28px',
              fontWeight: 300,
              color: '#2C1F14',
              marginBottom: '16px'
            }}>
              5. International Users
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Our website is accessible worldwide. If you visit from outside the UAE, your information may be transferred, stored, and processed outside the UAE, including countries where our service providers operate. By using our website, you consent to these transfers.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: '28px',
              fontWeight: 300,
              color: '#2C1F14',
              marginBottom: '16px'
            }}>
              6. Your Rights
            </h2>
            <p style={{ marginBottom: '12px' }}>
              Depending on your location, you may have rights to:
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '16px' }}>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Delete your personal information</li>
              <li>Object to processing</li>
              <li>Withdraw consent at any time</li>
            </ul>
            <p style={{ marginBottom: '16px' }}>
              To exercise your rights, contact us at{' '}
              <a href="mailto:stephanieluxesolutions@gmail.com" style={{ color: '#C4A882', textDecoration: 'underline' }}>
                stephanieluxesolutions@gmail.com
              </a>.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: '28px',
              fontWeight: 300,
              color: '#2C1F14',
              marginBottom: '16px'
            }}>
              7. Data Retention
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We retain personal information only as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required by law.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: '28px',
              fontWeight: 300,
              color: '#2C1F14',
              marginBottom: '16px'
            }}>
              8. Changes to This Privacy Policy
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We may update this Privacy Policy from time to time. The updated version will be indicated by the "Last updated" date at the top of this page. Please review periodically.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: '28px',
              fontWeight: 300,
              color: '#2C1F14',
              marginBottom: '16px'
            }}>
              9. Contact Us
            </h2>
            <p style={{ marginBottom: '16px' }}>
              If you have questions about this Privacy Policy or our privacy practices, please contact:
            </p>
            <p style={{ marginBottom: '8px' }}>
              <strong>Stephanies Luxe Solutions</strong><br />
              Email:{' '}
              <a href="mailto:stephanieluxesolutions@gmail.com" style={{ color: '#C4A882', textDecoration: 'underline' }}>
                stephanieluxesolutions@gmail.com
              </a>
            </p>
          </section>
        </div>

        {/* Back to Home */}
        <div style={{ marginTop: '60px', paddingTop: '40px', borderTop: '0.5px solid #DDD4C0' }}>
          <Link 
            to="/"
            style={{
              display: 'inline-block',
              padding: '12px 32px',
              background: '#2C1F14',
              color: '#F5F0E8',
              textDecoration: 'none',
              fontSize: '11px',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              fontWeight: 500
            }}
          >
            ← Back to Home
          </Link>
        </div>
      </article>

      {/* Footer */}
      <footer style={{
        background: '#221508',
        padding: '28px 48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '60px',
        color: '#9B7F5F'
      }}>
        <div style={{ fontSize: '7.5px', letterSpacing: '0.24em', textTransform: 'uppercase' }}>
          Stephanies Luxe Solutions
        </div>
        <div style={{ fontSize: '11px' }}>
          © 2025 · All rights reserved · UAE
        </div>
      </footer>
      </div>
    </>
  );
};

export default PrivacyPolicy;